import { apiRequest } from "./httpClient.js"

/** `server.properties` como texto plano — ver services/gateway/src/routes/config.ts. */
export function getServerConfig(serverId: string): Promise<{ content: string | null }> {
  return apiRequest(`/api/v1/servers/${serverId}/config`)
}

export function updateServerConfig(serverId: string, content: string): Promise<{ written: boolean }> {
  return apiRequest(`/api/v1/servers/${serverId}/config`, { method: "PUT", body: { content } })
}
